import React, { useState, useEffect } from "react";
//utils
import { useHistory } from "react-router";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
//component
import Header from "../../../components/molecules/Header";
import Gap from "../../../components/Gap";
import useStyles from "./style";
import SearchIcon from "@material-ui/icons/Search";
//material
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Skeleton } from "@material-ui/lab";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Divider,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@material-ui/core";
// import Mahkota1 from "../../../assets/icon/rank-1.svg";
import RankOuther from "../../../assets/icon/rankOuther.js";
import Rank3 from "../../../assets/icon/rank3.js";
import Rank2 from "../../../assets/icon/rank2.js";
import Rank1 from "../../../assets/icon/rank1.js";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import currency from "../../../utils/currency";

function Rank({ data }) {
  const number = data + 1;
  // console.log(number);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography style={{ zIndex: "1", fontSize: "x-small" }}>
        {number}
      </Typography>
      <div style={{ position: "absolute" }}>
        {number === 1 ? (
          <Rank1 />
        ) : number === 2 ? (
          <Rank2 />
        ) : number === 3 ? (
          <Rank3 />
        ) : (
          <RankOuther />
        )}
      </div>
    </div>
  );
}

function RekomendasiSaya() {
  const { profil } = useData();
  const classes = useStyles();
  const history = useHistory();
  const [statistic, setStatisticc] = useState({});
  const [load, setLoad] = useState(false);
  const loop = [1, 2, 3, 4, 5];
  useEffect(() => {
    const getTotalTransaksiSeller = async () => {
      setLoad(true);
      const transaksi = firefunctions.httpsCallable(
        "statistic-myRecommendation"
      );
      const res = await transaksi({});
      setStatisticc(res.data);
      setLoad(false);
    };
    getTotalTransaksiSeller();
  }, [profil.id]);
  // console.log(statistic);

  const [search, setSearch] = useState("");

  const productFilter = statistic?.recommendation_list?.filter((item) => {
    return (
      item?.nama?.toLowerCase()?.includes(search.toLowerCase()) ||
      item?.subdomain?.toLowerCase()?.includes(search.toLowerCase())
    );
  });

  return (
    <>
      <Header
        title="Rekomendasi Saya"
        type="with-title"
        onClick={() => history.goBack()}
      />
      <div className={classes.hero}>
        <Gap height={20} />
        <div className={classes.wrapHeader}>
          <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
            Leaderboard
          </Typography>
          <Button
            // fullWidth
            variant="outlined"
            // color="primary"
            style={{ backgroundColor: "#e9f3fc", borderColor: "#e9f3fc" }}
            size="small"
          >
            <Typography
              noWrap
              color="primary"
              style={{
                textTransform: "lowercase",
                fontSize: 10,
                fontWeight: "bold",
              }}
              variant="button"
            >
              komisi terbanyak
            </Typography>{" "}
          </Button>
        </div>
      </div>
      {/* <Gap height={18} /> */}
      {/* <Divider /> */}
      <FormControl
        style={{ display: "flex", margin: "20px" }}
        variant="outlined"
      >
        <InputLabel htmlFor="outlined-adornment-amount">Search</InputLabel>
        <OutlinedInput
          id="outlined-adornment-amount"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Cari team anda"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
          labelWidth={60}
        />
      </FormControl>
      {load ? (
        <div>
          {loop.map((item) => {
            return (
              <>
                <div
                  key={item}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: "3%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "1.5%",
                      width: "60%",
                    }}
                  >
                    <Avatar className={classes.medium}>
                      <Skeleton
                        variant="circle"
                        style={{
                          width: 50,
                          height: 50,
                        }}
                      />
                    </Avatar>
                    <div style={{ marginLeft: "1.5%", width: "200px" }}>
                      <div style={{ width: "80%" }}>
                        <Skeleton variant="text" />
                      </div>
                      <div style={{ width: "100%" }}>
                        <Skeleton variant="text" />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "40%",
                      // marginRight: "1,5%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div style={{ width: "100px", marginRight: "5%" }}>
                      <Skeleton variant="text" />
                    </div>
                  </div>
                </div>
                <Gap height={20} />
              </>
            );
          })}
        </div>
      ) : (
        <>
          {productFilter?.length > 0 ? (
            <>
              {productFilter?.map((item, index) => {
                return (
                  <>
                    <Accordion
                      elevation={0}
                      // key={index}
                      defaultExpanded
                      classes={{
                        root: classes.accordion,
                        expanded: classes.expanded,
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div style={{ display: "flex" }}>
                          <div className={classes.wrapItem}>
                            <Rank data={index} />
                            {/* <img src={Mahkota1} alt="mahkota1" /> */}
                            {/* <div style={{ display: "flex", justifyContent: "center" }}> */}
                            <Avatar className={classes.medium}>
                              <PermIdentityIcon color="primary" />
                            </Avatar>
                            {/* </div> */}
                          </div>
                          <div style={{ alignSelf: "center" }}>
                            <Typography
                              style={{
                                fontSize: "12px",
                                fontWeight: "bold",
                                textTransform: "capitalize",
                              }}
                            >
                              {item?.subdomain}
                              {" / "}
                              {item?.nama}
                            </Typography>
                            <Typography
                              style={{ fontSize: "10px", color: "darkgray" }}
                            >
                              komisi bulan ini{" "}
                            </Typography>
                            <Typography
                              color="primary"
                              style={{ fontSize: "11px", fontWeight: "bold" }}
                            >
                              {currency(item?.komisi)}
                            </Typography>
                          </div>
                        </div>{" "}
                      </AccordionSummary>
                      <AccordionDetails>
                        <ResponsiveContainer width="100%" height={200}>
                          <BarChart
                            width={500}
                            height={150}
                            data={statistic?.monthly_report}
                            margin={{
                              top: 20,
                              right: 30,
                              left: 20,
                              bottom: 5,
                            }}
                          >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="month" />
                            <YAxis />
                            <Tooltip
                              formatter={(value) =>
                                new Intl.NumberFormat("en").format(value)
                              }
                            />
                            <Bar dataKey={item?.subdomain} fill="#e9f3fc">
                              <LabelList
                                dataKey={item?.subdomain}
                                position="top"
                                formatter={(value) =>
                                  new Intl.NumberFormat("en").format(value)
                                }
                              />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>{" "}
                      </AccordionDetails>
                    </Accordion>
                    <Divider />
                  </>
                );
              })}
            </>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignContent: "center",
                width: "100%",
                padding: "20px",
                textAlign: "center",
                marginTop: "100px",
              }}
            >
              <p>
                <b>Team Anda Masih Kosong</b>
              </p>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default RekomendasiSaya;
